import { Box, Button, Typography } from '@mui/material';
import { Carousel } from 'components/@shared/Carousel';
import { BackdropLoader } from 'components/@shared/Loaders';
import { HomeFooter } from 'components/Home/Footer';
import { useDidMount } from 'hooks/useDidMount';
import isNull from 'lodash/isNull';
import { useCallback, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { getCurrentHomePageFormData } from 'services/homePageService';
import { HomePageInfo } from 'types/home-page';
import { buttonStyles, carouselBlockStyles, descriptionStyles, homeBackgroundStyles, titleStyles } from './styles';
import { PATH } from 'routes/path';

export const HomePage = () => {
    const [isLoading, setIsLoading] = useState<boolean>(true);
    const [info, setInfo] = useState<HomePageInfo | null>(null);

    const navigate = useNavigate();

    const handleClick = useCallback(() => navigate(PATH.CREATE_APPOINTMENT), [navigate]);

    useDidMount(() => {
        getCurrentHomePageFormData()
            .then(setInfo)
            .finally(() => {
                setIsLoading(false);
            });
    });

    return (
        <Box display="flex" flexDirection="column" width="100%" height="100%" overflow="auto">
            <Box mx="auto" flex={1} px={2.5}>
                {isLoading && <BackdropLoader />}
                <Box sx={homeBackgroundStyles}>
                    <Typography variant="h2" textAlign="center" sx={titleStyles}>
                        Welcome to Contalidi Lit It Electric LLC
                    </Typography>
                    {isNull(info) ? null : (
                        <>
                            <Box sx={carouselBlockStyles}>
                                <Carousel images={info.images} />
                            </Box>
                            <Box width="100%" textAlign="center">
                                <Button sx={buttonStyles} size="large" variant="contained" onClick={handleClick}>
                                    Add Appointment
                                </Button>
                            </Box>
                            <Typography sx={descriptionStyles}>{info.description}</Typography>
                        </>
                    )}
                </Box>
            </Box>
            <HomeFooter />
        </Box>
    );
};
